// src/reporting/pdf/addReportTable.js

import autoTable from "jspdf-autotable";
import { PDF_CONTENT_GAP, addSectionTitle, ensurePageSpace } from "./pdfLayout";
import { PDF_STONE } from "./pdfTheme";

export function addReportTable(ctx, config = {}, startY) {
  const { doc, margins } = ctx;

  const {
    title,
    columns = [],
    rows = [],
    foot = null,
    columnStyles = {},
    fontSize = 8,
    theme = "grid",
    styles = {},
    headStyles = {},
    alternateRowStyles = {},
    footStyles = {},
    tableWidth,
    didParseCell,
    titleOptions = {},
    pageBreak,
    rowPageBreak,
    showHead,
    showFoot,
  } = config;

  let y = startY;

  if (title) {
    y = ensurePageSpace(ctx, y, 40);
    y = addSectionTitle(ctx, title, y, titleOptions);
  }

  const head = [
    columns.map((c) => c.label || c.key || ""),
  ];

  const body = rows.map((row) =>
    columns.map((col) => {
      if (typeof col.format === "function") {
        return col.format(row[col.key], row);
      }

      return row[col.key] ?? "—";
    })
  );

  // derive alignment styles from column config
  const derivedColumnStyles = {};

  columns.forEach((col, idx) => {
    derivedColumnStyles[idx] = {
      halign: col.align || "left",
      ...(columnStyles[idx] || {}),
    };
  });

  autoTable(doc, {
    head,
    body,
    foot: foot ? [foot] : undefined,

    startY: y,

    margin: {
      left: margins.left,
      right: margins.right,
      bottom: margins.bottom,
      top: margins.top,
    },

    theme,

    styles: {
      font: "helvetica",
      fontSize,
      cellPadding: 3,
      lineColor: PDF_STONE.border,
      lineWidth: 0.25,
      textColor: [25, 25, 25],
      overflow: "linebreak",
      valign: "middle",
      ...styles,
    },

    headStyles: {
      fillColor: PDF_STONE.primary,
      textColor: PDF_STONE.white,
      fontStyle: "bold",
      halign: "center",
      ...headStyles,
    },

    alternateRowStyles: {
      fillColor: PDF_STONE.alternateRow,
      ...alternateRowStyles,
    },

    footStyles: {
      fillColor: [235, 235, 235],
      textColor: [20, 20, 20],
      fontStyle: "bold",
      ...footStyles,
    },

    columnStyles: derivedColumnStyles,
    ...(tableWidth ? { tableWidth } : {}),
    ...(pageBreak ? { pageBreak } : {}),
    ...(rowPageBreak ? { rowPageBreak } : {}),
    ...(showHead ? { showHead } : {}),
    ...(showFoot ? { showFoot } : {}),
    ...(typeof didParseCell === "function" ? { didParseCell } : {}),
  });

  return (doc.lastAutoTable?.finalY || y) + PDF_CONTENT_GAP;
}
